import React, { useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import gs1_logo from "../../assets/img/gs1.png";
import GLOBALS from "../../utils/Globals";
import Image from "react-bootstrap/Image";

const ButtonRenderer = (props) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [company, setCompany] = React.useState(null);
  const [type, setType] = React.useState(null);
  const [status, setStatus] = React.useState(null);

  const [r_desc, setR_desc] = React.useState(null);
  const [r_date, setR_date] = React.useState(null);
  const [r_id, setR_id] = React.useState(null);
  const [recall, setRecall] = React.useState(null);

  const [thegtin, setTheGtin] = React.useState(null);
  const [gln, setGln] = React.useState(null);

  const [dcreated, setDcreated] = React.useState(null);
  const [dupdated, setDupdated] = React.useState(null);

  const baseURLGetGTINS =
    process.env.REACT_APP_ENV == "PROD"
      ? GLOBALS.PROD.baseURLGetGTINS
      : GLOBALS.DEV.baseURLGetGTINS;

  //var gtin = props.data.GTIN;

  //console.log(props.data.json)

  React.useEffect(() => {
    if (props.data.json === null) {
      console.log("null");
      
    } else {
      //console.log(props.data.json)
      setCompany(props.data.json.gs1Licence.licenseeName);
      setType(props.data.json.gs1Licence.licenceType);
      setStatus(props.data.json.gtinRecordStatus);
      setTheGtin(props.data.json.gtin);
      setGln(props.data.json.gs1Licence.licenseeGLN);
      setDupdated(props.data.json.gs1Licence.dateUpdated);
      setDcreated(props.data.json.gs1Licence.dateCreated);
      setR_desc(props.data.json.Description);
      setR_date(props.data.json.RecallDate);
      setR_id(props.data.json.RecallID);
      setRecall(props.data.json.recall);
    }
    
    

    //console.log(gtin)

    //console.log(gtin_tmp.length)

    // let gtin_tmp = gtin.toString();

    // if (gtin_tmp.length === 11) {
    //   //console.log(11);
    //   gtin = "000" + gtin;
    // }

    // if (gtin_tmp.length === 9) {
    //   //console.log(9);
    //   gtin = "00000" + gtin;
    // }

    // if (gtin_tmp.length === 12) {
    //   //console.log(12);
    //   gtin = "00" + gtin;
    // }

    //console.log(gtin);

    //console.log(baseURLGetGS1 + "/" + gtin)

    // axios.get(baseURLGetGTINS + "/" + gtin).then((response) => {
    //   console.log(response.data.products);
    //   if (response.data == null) {
    //     console.log("its null");
    //   } else {
    //     setCompany(response.data.products.gs1Licence.licenseeName);
    //     setType(response.data.gs1Licence.licenceType);
    //     setStatus(response.data.gtinRecordStatus);
    //     setTheGtin(response.data.gtin);
    //     setGln(response.data.gs1Licence.licenseeGln);
    //     setDupdated(response.data.gs1Licence.dateUpdated);
    //     setDcreated(response.data.gs1Licence.dateCreated);
    //     setR_desc(response.data.Description);
    //     setR_date(response.data.RecallDate);
    //     setR_id(response.data.RecallID);
    //     setRecall(response.data.recall);
    //   }
    // });
  }, []);

  return (
    <>
      <Button variant="outline-primary" onClick={handleShow}>
        DETAILS
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>GTIN Details for {props.data.GTIN}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src={gs1_logo} width="120px" height="120px" alt="GS1" />
          <br></br>
          <hr></hr>
          <br></br>
          Company Name : {company}
          <br></br>
          Type : {type}
          <br></br>
          Status : {status}
          <br></br>
          GTIN : {props.data.GTIN}
          <br></br>
          GLN : {gln}
          <br></br>
          Date Created : {dcreated}
          <br></br>
          Date Updated : {dupdated}
          <br></br>
          <br></br>
          {recall ? (
            <div>
              <h3>Recall Information</h3>
              <hr></hr>
              <br></br>
              Recall ID : {r_id}
              <br></br>
              Recall Date : {r_date}
              <br></br>
              Recall Description : {r_desc}
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ButtonRenderer;
